import { IS_UPCOMING_SESSIONS_ENABLED } from '@/app-shell/flags/session-flags';
import { useIntegrationEhrInfo } from '@/hooks/integrations/useIntegrationEhrInfo';
import { isLetterSenderEHRProvider } from '@heidi/integrations/letters';

export const useShouldUseUpcomingSessions = () => {
  const { integrationEhrProvider } = useIntegrationEhrInfo();

  return (
    IS_UPCOMING_SESSIONS_ENABLED() &&
    (!integrationEhrProvider || isLetterSenderEHRProvider(integrationEhrProvider))
  );
};
